<template>

    <li class="dd-m-graphic__line-item">
        <label class="dd-m-graphic__line-item__legend">
            {{item.label}} [{{item.value}}%]
            <i class="dd-m-icon icon-question dd-m-tooltip"
               v-tooltip.top-center="{content: item.tooltip, offset: '5',
            trigger: 'hover click focus', classes: 'dd-m-tooltip--centered'}"></i>
        </label>
        <div class="dd-m-graphic__line-item__bar">
            <span class="dd-m-graphic__line-item__progress"
                  v-bind:style="{'width' : item.value + '%'}"></span>
        </div>
    </li>

</template>
<script>
    export default {
        name: 'graphic-line-item',
        props: ['item'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/graphics/graphic-line-item.vue